//API
import { getRequest, postRequest, putRequest } from "../globalService"

const endPoint = 'coach';

export const getCoach = (idCoach)=> {
    return getRequest(`${endPoint}/${idCoach}`,true)
}

export const updateCoach = (idCoach, body = {})=> {
    return putRequest(`${endPoint}/${idCoach}`, body, true)
}

export const customUI = (coachId, body = {})=> {
    return postRequest(`${endPoint}/custom/${coachId}`, body, true)
}

export const getRecurring = (coachId)=> {
    return getRequest(`${endPoint}/recurring/${coachId}`, true)
}

export const getRecurringCalendar = (coachId)=> {
    return getRequest(`${endPoint}/recurring-calendar/${coachId}`, true)
}

export const getAvailabilityDays = (coachId)=> {
    return getRequest(`${endPoint}/availability/days/${coachId}`, true)
}